import {
    Users,
    CheckCircle2,
    XCircle,
    ShieldCheck,
} from "lucide-react";

function AdminUserStats({
    admins,
}) {

    const totalAdmins = admins.length;

    const activeAdmins = admins.filter(
        (admin) => admin.status === "Active"
    ).length;

    const inactiveAdmins = admins.filter(
        (admin) => admin.status === "Inactive"
    ).length;

    const uniqueRoles = new Set(
        admins.map((admin) =>
            admin.role?.roleName || "No Role"
        )
    ).size;

    return (

        <div className="admin-users-overview">

            <div className="overview-card">

                <Users size={40} />

                <div>

                    <h2>{totalAdmins}</h2>

                    <p>Total Admins</p>

                </div>

            </div>

            <div className="overview-card">

                <CheckCircle2 size={40} />

                <div>

                    <h2>{activeAdmins}</h2>

                    <p>Active Admins</p>

                </div>

            </div>

            <div className="overview-card">

                <XCircle size={40} />

                <div>

                    <h2>{inactiveAdmins}</h2>

                    <p>Inactive Admins</p>

                </div>

            </div>

            <div className="overview-card">

                <ShieldCheck size={40} />

                <div>

                    <h2>{uniqueRoles}</h2>

                    <p>Assigned Roles</p>

                </div>

            </div>

        </div>

    );

}

export default AdminUserStats;